import script from "./FormMixin.vue?vue&type=script&lang=js"
export * from "./FormMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__